import classnames from 'classnames';
import { useTranslator } from '@picsart/rc/services/localization';
import {
  Button,
  ButtonVariants,
  ButtonElementTypes,
  ButtonSkinPrimary,
  ButtonSizeLG,
} from '@picsart/design-system/components/Button';
import Title from '@picsart/growth-rc/Title';
import Description from '@picsart/growth-rc/Description';

import withFetchTemplates from 'components/Decorators/withFetchTemplates/withFetchTemplates';
import { HorizontalContainer } from '@picsart/design-system/components/HorizontalContainer';
import useStyles from './styles';
import { SuggestedTemplatesProps } from './types';
import { MoreText, templatesLimit } from './constants';
import Content from './Content';

const SuggestedTemplates = ({
  className,
  title,
  description,
  link,
  backgroundColor,
  templateData,
  isLoading,
  error,
  scrollCount,
}: SuggestedTemplatesProps) => {
  const classes = useStyles({ backgroundColor });
  const translate = useTranslator();

  const buttonArgs = { url: link?.url || '/templates', text: translate(link?.text || MoreText) };

  return (
    <HorizontalContainer>
      <div
        className={classnames(classes.root, className)}
        data-pulse-section-group="suggested-templates"
      >
        <div className={classes.container} data-pulse-section="templates">
          <div className={classes.textContainer}>
            <Title className={classes.title} {...title} />
            {description && <Description className={classes.description} {...description} />}
          </div>
          <Button
            href={buttonArgs.url}
            size={ButtonSizeLG}
            variant={ButtonVariants.Text}
            skin={ButtonSkinPrimary}
            tag={ButtonElementTypes.Link}
            data-pulse-name={MoreText}
          >
            {buttonArgs.text}
          </Button>
        </div>
        <div className={classes.content}>
          <Content
            isLoading={isLoading}
            isError={error}
            templates={templateData}
            scrollCount={scrollCount}
          />
        </div>
      </div>
    </HorizontalContainer>
  );
};

export default withFetchTemplates(SuggestedTemplates, templatesLimit);
